module.exports = __webpack_public_path__ + "img/ft-media-picker-on.b2de75c7.svg";